/**
 * A set of regular expressions for string matching
 * @module matchers
 */

/**
 * guid
 * @memberof matchers
 * @example f5e08ec7-8a56-e311-8719-0025906126df
 */
export const guid =
  /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

export const lookupIdMatcher = /[0-9]+-[0-9]+/;

export const phone =
  /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;

// RegEx source: https://colinhacks.com/essays/reasonable-email-regex
//
// Validation rules:
//
// The local part (before `@`)
//   - May contain letters, digits, and these special characters: _ ' + - .
//   - May not contain two consecutive dots
//   - May not start or end with a dot
//
// The domain (after `@`)
//   - Must consist of two or more dot-separated labels
//   - Each label may contain letters, digits, and hyphens, and must start with
//     a letter or digit (no leading hyphen)
//   - Must end with a TLD of 2 or more letters
export const basicEmail =
  /^(?!\.)(?!.*\.\.)([a-z0-9_'+\-.]*)[a-z0-9_+-]@([a-z0-9][a-z0-9-]*\.)+[a-z]{2,}$/i;

export default { guid, phone };
